import { render, staticRenderFns } from "./MetricComment.vue?vue&type=template&id=13080c8a&scoped=true&"
import script from "./MetricComment.vue?vue&type=script&lang=js&"
export * from "./MetricComment.vue?vue&type=script&lang=js&"
import style0 from "./MetricComment.vue?vue&type=style&index=0&id=13080c8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13080c8a",
  null
  
)

export default component.exports